<template>
  <div>
    <checkbox-input v-model="settings.displayCorporateSite">Display Corporate Site</checkbox-input>
    <checkbox-input v-model="settings.displayHelp">Display Help ("contact support")</checkbox-input>
    <checkbox-input v-model="settings.displayFAQ">Display FAQ ("help")</checkbox-input>
  </div>
</template>

<script>
import CheckboxInput from '../../../ui/inputs/CheckboxInput';

export default {
  components: {
    CheckboxInput
  },
  props: {
    settings: { type: Object }
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/blade/pages/components/SignInConfigEditor.vue